import { useSelector, useDispatch } from 'react-redux';
import { startTour, stopTour, setStepIndex, setSteps, resetTour } from '../services/Tour/tourSlice';

export const useGuidedTour = () => {
  const isTourRunning = useSelector((state) => state.tour.run);
  const currentStepIndex = useSelector((state) => state.tour.stepIndex);
  const dispatch = useDispatch();

  const toggleTour = () => {
    if (isTourRunning) {
      dispatch(stopTour());
    } else {
      dispatch(startTour());
    }
  };

  const goToStep = (index) => {
    // localStorage write was previously a side effect of the action creator.
    // It now lives here so the slice reducer can stay pure.
    localStorage.setItem('tourStepIndex', String(index));
    dispatch(setStepIndex(index));
  };

  const initializeSteps = (steps) => {
    dispatch(setSteps(steps));
  };

  const resetTheTour = () => {
    dispatch(resetTour());
  };

  return { isTourRunning, toggleTour, currentStepIndex, goToStep, initializeSteps, resetTheTour };
};
